<template>
  <StackLayout class="wrapper" role="dialog" aria-modal="true">
    <AgCaption noMargin v-if="titleText" :text="titleText" :id="titleId" />
    <fieldset class="checkbox-group" role="group" :aria-labelledby="titleText ? titleId : null" aria-label="Checkbox Optionen">
      <GridLayout
        v-for="(item, index) in items"
        :key="index"
        class="checkbox-item"
        :columns="item.label > 0 ? '40, *' : 'auto'"
        role="checkbox"
        :aria-checked="isSelected(item)"
        :aria-label="item.label"
        tabindex="0"
        @tap="toggleSelection(item)"
        @click="toggleSelection(item)"
        @keydown="handleKeydown($event, item)"
        :ref="'checkboxItem' + index"
      >
      <AgIcon
        col="0"
        :type="isSelected(item) ? 'fas:checkSquare' : 'far:square'"
        :color="isSelected(item) ? color : greyColor"
        size="24"
        verticalAlignment="top"
        :decorative="true"
      />
      <StackLayout col="1">
        <Label class="label" :text="item.label" textWrap />
      </StackLayout>
      </GridLayout>
    </fieldset>

    <FlexboxLayout class="actions" justifyContent="center" role="group" aria-label="Aktionen">
      <AgButton outlined small icon="times" @click="cancelSelection" @tap="cancelSelection" aria-label="Abbrechen" />
      <AgButton outlined small icon="check" @click="confirmSelection" @tap="confirmSelection" aria-label="Bestätigen" />
    </FlexboxLayout>
  </StackLayout>
</template>

<script>
import { colors } from "@/helpers/ui";

export default {
  props: {
    titleText: String,
    items: Array,
    selected: Array,
    titleId: {
      type: String,
      default: 'checkbox-title'
    }
  },
  data() {
    return {
      selections: [],
      initialSelections: [],
      color: colors.primary,
      greyColor: colors.grey,
    };
  },
  methods: {
    isSelected(item) {
      return this.selections?.includes(item.value);
    },
    toggleSelection(item) {
      const index = this.selections ? this.selections.indexOf(item.value) : -1;
      if (index === -1) {
        this.selections.push(item.value);
      } else {
        this.selections.splice(index, 1);
      }
    },
    confirmSelection() {
      this.$emit("done", this.selections);
    },
    cancelSelection() {
      this.selections = [...this.initialSelections];
      this.$emit("done", null);
    },
    resetSelections() {
      this.initialSelections = [...(this.selected ?? [])];
      this.selections = this.selected ? [...this.selected] : [];
    },
    handleKeydown(event, item) {
      if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
        event.preventDefault();
        event.stopPropagation();
        this.toggleSelection(item);
      }
    }
  },
  watch: {
    selected: {
      immediate: true,
      handler() {
        this.resetSelections();
      }
    }
  },
  mounted() {
    this.resetSelections();
  },
};
</script>

<style scoped>
.wrapper {
  padding: 20px;
}

.checkbox-item {
  display: flex;
  align-items: center;
  margin: 10px 0;
  cursor: pointer;
  user-select: none;
  padding: 8px;
  border-radius: 4px;
  border: 2px solid transparent;
}

.checkbox-item:focus {
  outline: none;
  border-color: #004e9e;
  background-color: rgba(0, 78, 158, 0.1);
}

.checkbox-item:hover {
  background-color: rgba(0, 78, 158, 0.05);
}

.label {
  margin-left: 10px;
  font-size: 18px;
  line-height: 24px;
  font-weight: regular;
  color: #3b3b3b;
}

.actions {
  margin-top: 20px;

  .button {
    margin: 0 10px;
  }
}

.checkbox-item .checked {
  color: #004e9e; 
}

.checkbox-item .unchecked {
  color: #c6c6c6; 
}
</style>
